import { ENVIRONMENT_FAVICONS } from './app.consts';

/**
 * Which favicon a host should show, or nothing where the default one is right.
 *
 * Everything that is not a named environment — a developer's machine, a review
 * deployment, an address nobody anticipated — keeps the plain icon rather than
 * being guessed at.
 * @param {string} hostname The host the app is being served from.
 * @returns {string | undefined} The icon's file name, or nothing.
 */
export const faviconForHost = (hostname: string): string | undefined =>
  ENVIRONMENT_FAVICONS[(hostname.split('.')[0] ?? '').toLowerCase()];
